import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { getClubPackageByClubId } from './api';
import {
  GET_CLUB_PACKAGE_BY_CLUBID_REQUEST,
  CLUB_PACKAGE_REQUESTING,
  GET_CLUB_PACKAGE_SUCCESS,
  RESET_CLUB_PACKAGE_ISFETCHING
} from './constants';

export function* getByClubId(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_PACKAGE_REQUESTING });
    try {
      const response = yield call(getClubPackageByClubId, action.clubId);
      yield put({ type: GET_CLUB_PACKAGE_SUCCESS, payload: response.data });
      return response.data;
    } catch (err) {
      if (err.response && err.response.status === 404) {
        yield put({ type: RESET_CLUB_PACKAGE_ISFETCHING });
      } else {
        throw new Error(err);
      }
    }
    return null;
  } catch (error) {
    yield put({ type: RESET_CLUB_PACKAGE_ISFETCHING });
    yield call(addAPIError, error);
    return null;
  }
}

export function* watchList() {
  yield takeLatest(GET_CLUB_PACKAGE_BY_CLUBID_REQUEST, getByClubId);
}

export default function* clubSagas() {
  yield all([watchList()]);
}
